<template>
  <ProductPage
    :theme="theme"
    :page-meta="pageMeta"
    :sections="sections"
    :features="features"
    :architecture="architecture"
    :why-us="whyUs"
    :scenarios="scenarios"
    :related-products="relatedProducts"
    contact-path="/digital-village"
    default-product="数字乡村系统"
  />
</template>

<script>
import ProductPage from '../components/ProductPage.vue'
import {
  theme,
  pageMeta,
  sections,
  features,
  architecture,
  whyUs,
  scenarios,
  relatedProducts
} from '../data/digital-village'

export default {
  name: 'DigitalVillage',
  components: { ProductPage },
  data() {
    return {
      theme,
      pageMeta,
      sections,
      features,
      architecture,
      whyUs,
      scenarios,
      relatedProducts
    }
  }
}
</script>
